export const services = [
  {
    title: '3D Marketing Websites',
    text: 'Launch sites that people explore instead of scroll. Cinematic WebGL scenes, scroll-driven storytelling and real-time 3D that loads fast and runs smoothly on every device.',
  },
  {
    title: 'Product Configurators',
    text: 'Cars, jewellery, furniture, sneakers: let customers spin, open and customise your product in photoreal 3D, right in the browser. No app, no download.',
  },
  {
    title: 'Virtual Worlds',
    text: 'Explorable brand worlds and metaverse spaces on the open web. Showrooms, events and hangouts people can walk through with nothing more than a link.',
  },
  {
    title: 'Web Games',
    text: 'Playable campaigns, browser games and interactive toys that people actually share. Built for instant play on desktop and mobile.',
  },
  {
    title: 'Interactive Storytelling',
    text: 'Immersive narratives, digital exhibitions and spatial portfolios where scenes replace pages and every scroll moves the story forward.',
  },
  {
    title: 'AI-Powered 3D',
    text: 'Characters, assistants and generative scenes with personality, like Pixel. AI speeds up how we build worlds and makes them react to every visitor.',
  },
];
